import { QUERY_POST_WORKSHOPLIST,QUEY_GET_MASTER_COUNT } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const postWorkshopList = baseThunk("workshopList/postWorkshopList", QUERY_POST_WORKSHOPLIST, "GET")
export const postWorkshopCount = baseThunk("workshopList/postWorkshopCount",QUEY_GET_MASTER_COUNT,"GET");